import {InputText} from '@/components/commons/input-text/InputText'
import {Switch} from '@/components/commons/switch/Switch'
import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {AgendaEventFieldsSchema} from '@/features/agenda/formSchemas'
import {useTranslation} from '@/translations/i18n'
import {useController, useFormContext} from 'react-hook-form'
import {z} from 'zod'

const AgendaEventRemoteFieldsSchema = AgendaEventFieldsSchema.pick({
    isRemote: true,
    remoteUrl: true
})
type AgendaEventRemoteFieldsSchema = z.infer<typeof AgendaEventRemoteFieldsSchema>

export const AgendaEventRemoteFields = () => {
    const {t} = useTranslation()
    const {control, setValue} = useFormContext<AgendaEventRemoteFieldsSchema>()
    const {field: remoteField} = useController({control, name: 'isRemote'})
    const remoteUrlField = useController({control, name: 'remoteUrl'})

    return (
        <Flexbox align={remoteUrlField.fieldState.error ? 'flex-start' : 'center'} gap={4}>
            <Switch
                label={t('agenda:remote_switch_label')}
                defaultChecked={!!remoteField.value}
                size="sm"
                onChange={() => {
                    remoteField.onChange(!remoteField.value)
                    setValue('remoteUrl', null)
                }}
            />
            {remoteField.value && (
                <InputText
                    type="url"
                    placeholder={t('agenda:remote_switch_placeholder')}
                    value={remoteUrlField.field.value || ''}
                    onChange={e => remoteUrlField.field.onChange(e.target.value)}
                    errorMessage={remoteUrlField.fieldState.error?.message}
                />
            )}
        </Flexbox>
    )
}
